import React from 'react'
import { Link } from 'react-router-dom'
import { Table, Tag, Space, Button, Modal, Dropdown, Menu, message } from 'antd'
import { EditOutlined, SettingOutlined } from '@ant-design/icons'
import { ListComponent, BaseListComponentProps } from '../BaseComponent'
import { SearchRequest, ShelterToggleActiveRequest } from '../../services/api/interfaces/ApiRequest'
import { Pagination } from 'components/Pagination'

type ShelterListProps = BaseListComponentProps & {
  loading: boolean,
  shelters: any,
  pagination: any,

  searchOptions: any,

  history: any,
  editing?: any,

  loadShelters: (args: SearchRequest) => void,
  toggleActive: (args: ShelterToggleActiveRequest) => Promise<any>
}

export default class ShelterList extends ListComponent<ShelterListProps> {

  static defaultProps = {
    loading: false,
    shelters: [],

    loadShelters: () => {}
  }

  tableColumns = [
    {
      title: 'UUID',
      dataIndex: 'uuid',
      key: 'uuid',
      responsive: ['md'] as any,
      sorter: (a: any, b: any) => a.uuid - b.uuid
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (a: any, b: any) => a.name - b.name
    },
    {
      title: 'E-mail',
      dataIndex: 'email',
      key: 'email',
      responsive: ['md'] as any,
      sorter: (a: any, b: any) => a.email - b.email
    },
    {
      title: 'Contract',
      dataIndex: 'contract',
      key: 'contract',
      responsive: ['md'] as any,
      sorter: (a: any, b: any) => a.contract - b.contract,
      render: (text: string, record: any) => (
        <Tag color={record.contract ? 'green' : 'orange'}>{record.contract ? 'Yes' : 'No'}</Tag>
      )
    },
    {
      title: 'In Person',
      dataIndex: 'in_person',
      key: 'in_person',
      responsive: ['md'] as any,
      sorter: (a: any, b: any) => a.in_person - b.in_person,
      render: (text: string, record: any) => (
        <Tag color={record.in_person ? 'green' : 'orange'}>{record.in_person ? 'Yes' : 'No'}</Tag>
      )
    },
    {
      title: 'Active',
      dataIndex: 'active',
      key: 'active',
      responsive: ['md'] as any,
      sorter: (a: any, b: any) => a.active - b.active,
      render: (text: string, record: any) => (
        <Tag color={record.active ? 'green' : 'orange'}>{record.active ? 'Yes' : 'No'}</Tag>
      )
    },
    {
      title: 'Actions',
      key: 'action',
      render: (text: string, record: any) => (
        <Space size='middle'>
          <Link to={`shelter/${record.uuid}`} ref={(refs) => this.actionRefs.edit.push(refs)}>
            <Button type="dashed" shape="round" icon={<EditOutlined />} />
          </Link>

          <div ref={(refs) => this.actionRefs.edit.push(refs)}>
            <Dropdown overlay={this.renderActions(record)} placement="bottomRight" trigger={['click']}>
              <Button type="dashed" shape="round" icon={<SettingOutlined />} />
            </Dropdown>
          </div>
        </Space>
      )
    }
  ]

  protected load() {
    this.searchOptions = {
      search: {
        ...this.props.searchOptions.search
      },
      options: {
        ...this.props.searchOptions.options
      }
    }

    this.props.loadShelters(this.searchOptions)
  }

  handleShelterActiveToggle = (uuid: string, name: string, toggle: boolean) => {
    const { toggleActive } = this.props

    Modal.confirm({
      title: `${toggle ? 'Activate Shelter' : 'Deactivate Shelte'}`,
      content: `Are you sure about ${toggle ? 'activating' : 'deactivating'} ${name}?`,
      okText: `Yes, I'm sure!`,
      cancelText: 'No',
      onOk() {
        return toggleActive({
          organization_shelter_uuid: uuid,
          active: toggle
        })
        .then(() => message.success(`${name} ${toggle ? 'activated' : 'deactivated'} successfully!`))
        .catch(err => message.error(`Failed to ${toggle ? 'activating' : 'deactivating'} shelter. Error: ${err}`))
      }
    })
  }

  renderActions = (record: any) => {
    const { uuid, name, active } = record

    return (
      <Menu>
        <Menu.Item onClick={() => this.handleShelterActiveToggle(uuid, name, !active)}>
          {!active ? 'Activate Shelter' : 'Deactivate Shelter'}
        </Menu.Item>
      </Menu>
    )
  }

  render() {
    const { loading, pagination, shelters, loadShelters } = this.props


    return (
      <>
        <Table
          loading={loading}
          rowKey='uuid'
          columns={this.tableColumns}
          pagination={false}
          dataSource={shelters}
          onChange={(pagination: any, filters: any, sorter: any) => this.handleTableChange(pagination, sorter, loadShelters)}
        />
         <Pagination
          loading={loading}
          current={pagination?.page}
          pageSize={pagination?.limit}
          length={shelters?.length}
          onChange={(pagination) =>
            this.handleTableChange(
              pagination,
              undefined,
              loadShelters
            )
          }
        />
      </>
    )
  }
}
